module.exports = __webpack_public_path__ + "media/coffee-preferences/brew_method_pour_over-29c20438.png";